/* eslint-disable no-console */
import { useState, useEffect } from "react";
// import { VentasListado } from "../../components/index";
import { useAuthContext } from "../../context/auth";
import { getClientesPublicitarios, getVentas } from "../../utils";
import "./stylesSales.scss";

function Sales() {
  // eslint-disable-next-line no-unused-vars
  const [ventas, setVentas] = useState([]);
  // eslint-disable-next-line no-unused-vars
  const [clientesPublicitarios, setClientesPublicitarios] = useState([]);
  // eslint-disable-next-line no-unused-vars
  const [intermediarios, setIntermediarios] = useState([]);

  const { pais } = useAuthContext();

  useEffect(() => {
    const initialize = async () => {
      const newClientesPublicitarios = await getClientesPublicitarios({ pais });
      setClientesPublicitarios(newClientesPublicitarios);

      const newIntermediarios = await getIntermediarios({ pais });
      setIntermediarios(newIntermediarios);

      const newVentas = await getVentas({ pais });
      setVentas(newVentas);
    };

    initialize();
  }, [pais]);

  return <div className="Sales" />;
}

export default Sales;
